import axios from 'axios';
import { message } from 'antd';
import {
  REFUND_API,
} from '../../../constants/API';
import {
  UPDATE_REFUND_LOADING
} from '../types';

function updateOrder(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: UPDATE_REFUND_LOADING,
        creatingRefund: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const putData = {
          ...data,
          userId: userData.id
        };
        await axios.put(`${REFUND_API}/${data.id}`, putData, { headers: {"Authorization" : `Bearer ${accessToken}`} })

        dispatch({
          type: UPDATE_REFUND_LOADING,
          creatingRefund: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: UPDATE_REFUND_LOADING,
          creatingRefund: false
        });
        console.log(e);
      }
  }
}
export default updateOrder;
